// extracted by mini-css-extract-plugin
module.exports = {"sectionLeftCol":"sectionQuote_sectionLeftCol__85uWp","sectionRightCol":"sectionQuote_sectionRightCol__lYpMg","quoteIcon":"sectionQuote_quoteIcon__IKAPI"};